// This file was automatically generated from appchart.refpanel.referrals.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.referrals');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.order.referral');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.referrals.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="referral-summary" class="fieldLabelContainerNoBorder">');
  if (opt_data.items.length) {
    output.append('<ol>');
    var itemList5806 = opt_data.items;
    var itemListLen5806 = itemList5806.length;
    for (var itemIndex5806 = 0; itemIndex5806 < itemListLen5806; itemIndex5806++) {
      var itemData5806 = itemList5806[itemIndex5806];
      output.append('<li class="el8BulletText', (opt_data.hasActions) ? ' el8ItemHover' : '', '">', (opt_data.hasActions) ? '<div class="el8ItemButtonContainer"><button tabindex="-1" type="button" orderId="' + soy.$$escapeHtml(itemData5806.id) + '" class="el8button add-to-note-trigger el8ItemButton">Ref (Data)</button></div>' : '', '<a class="referral-history-trigger"', (itemData5806.specialtyId) ? ' specialtyId="' + soy.$$escapeHtml(itemData5806.specialtyId) + '"' : '', '>');
      el8.template.ptdata.model.order.referral.refPanelSummary(itemData5806, output);
      output.append('</a></li>');
    }
    output.append('</ol>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
